export const isEbury = () => window.location.hostname.includes('ebury')
